import Column from '@amzn/meridian/column';
import Divider from '@amzn/meridian/divider';
import React, { useCallback, useEffect, useState } from 'react';
import { useHrpsApi } from '../../clients/useHrpsApi';
import { DocumentAttachment } from '../../types';
import { Document, DocumentListPopup } from './DocumentListPopup';
import { PurchaseOrderDocumentUploader } from './PurchaseOrderDocumentUploader';

type PurchaseOrderAttachmentsModalProps = {
    purchaseOrderId: string;
    shipmentId: string;
    resellerId: string;
    username: string;
};

export const PurchaseOrderAttachmentsModal = ({
    purchaseOrderId,
    shipmentId,
    resellerId,
    username,
}: PurchaseOrderAttachmentsModalProps) => {
    const {
        returnOrders: { getSalesOrderDocuments },
    } = useHrpsApi();
    const [documents, setDocuments] = useState<Document[]>([]);

    const refresh = useCallback(() => {
        getSalesOrderDocuments(resellerId, purchaseOrderId, shipmentId)
            .then((attachments) => {
                setDocuments(
                    attachments.map((doc) => ({
                        documentId: doc.id,
                        name: doc.name,
                        description: doc.description ?? '',
                        uploadTimestamp: doc.uploadedAt,
                    }))
                );
            })
            .catch(() => {
                // leave existing local state intact on transient failure
            });
    }, [getSalesOrderDocuments, resellerId, purchaseOrderId, shipmentId]);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const onDocumentUploaded = useCallback(
        (_attachment: DocumentAttachment) => {
            refresh();
        },
        [refresh]
    );

    return (
        <Column spacing={'medium'} data-testid={'purchaseOrderAttachmentsModal'}>
            <DocumentListPopup
                documents={documents}
                onDocumentDownload={() => {
                    // TODO: wire to getSalesOrderDocumentUrl when backend lands
                }}
            />
            <Divider size={'small'} />
            <PurchaseOrderDocumentUploader
                purchaseOrderId={purchaseOrderId}
                shipmentId={shipmentId}
                username={username}
                onDocumentUploaded={onDocumentUploaded}
            />
        </Column>
    );
};
